export enum LockerStatus {
  UP = "Functionala",
  DOWN = "Nefunctionala",
  ON_HOLD = "In asteptare",
}

export enum NewcomeUserStatus {
  // ACCEPTED = "VERIFIED",
  // NOT_ACCEPTED = "INACTIVE",
  // ON_HOLD = "ACTIVE",
  // BLACKLIST = "BLACKLIST",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  VERIFIED = "VERIFIED",
  VERIFICATION_IN_PROGRESS = "VERIFICATION_IN_PROGRESS",
  DEACTIVATED = "DEACTIVATED",
  BLACKLIST = "BLACKLIST",
  BLOCKED = "BLOCKED",
  REJECTED = "REJECTED",
  MINOR = "MINOR"
}

export enum ReportStatus {
  RESOLVED = "Rezolvat",
  UNRESOLVED = "Nerezolvat",
}

export enum Tabs {
  PAYMENTS = "payments",
  RENTALS = "rentals",
  USERS = "users",
  RENTALS_LOGS = "rentals_logs",
  SMS_LOGS = "sms_logs",
  INVOICES_LOGS = "invoices_logs"
}

export enum ButtonTypes {
  MAIN_BUTTON = "main_button",
  SECONDARY_BUTTON_DEFAULT = "secondary_button_default",
  SECONDARY_BUTTON_CANCEL = "secondary_button_cancel",
  SECONDARY_BUTTON_INACTIVE = "secondary_button_inactive",
  ICON_BUTTON_HISTORY = "icon_button_history",
  ICON_BUTTON_EDIT = "icon_button_edit",
  ICON_BUTTON_DELETE = "icon_button_delete",
  SECONDARY_BUTTON = "secondary_button",
  THIRD_BUTTON = "third_button",
  OUTLINED_BUTTON = "outlined_button",
  DISABLED = "disabled",
  NEW_BUTTON = "new_button",
  NEW_OUTLINED_BUTTON = "new_outlined_button",
  NEW_MAIN_BUTTON = "new_main_button",
}

export enum InputTypes {
  LOGIN_INPUT = "login",
  MODAL_INPUT = "modal",
  PASSWORD_INPUT = "password",
  DATE_INPUT = "date"
}

export enum ModalTypes {
  USER = "user",
  REPORT = "report",
  DOOR = "door",
  RENTAL = "rental",
  NOTIFICATION = "notification",
  SETTINGS = "settings",
  LANGUAGE = "language",
  DISCOUNT_DELETE_CONFIRMATION = "confirmation",
  ADD_CATEGORY = "add_category",
  ADD_SUBCATEGORY = "add_subcategory",
  ADD_ARTICLE = "add_article",
  EDIT_CATEGORY = "edit_category",
  EDIT_SUBCATEGORY = "edit_subcategory",
  EDIT_ARTICLE = "edit_article",
  EDIT_USER_STATUS = "edit_user_status",
  SELECT_USERS = "select_users",
  EDIT_PROMO_CODE = "edit_promo_code",
  ADD_NEW_LOCKER = "add_new_locker"
}

export enum ChildModalTypes {
  ID = "id",
  EQUIPMENT = "equipment",
  POWER_UP = "power_up",
}

export enum DoorStatusEnum {
  OPENED = "OPENED",
  CLOSED = "CLOSED",
}
export enum NotificationTypes {
  HIRE = "hire",
  PAYMENTs = "payment",
  USER = "user",
  REPORTS = "reports",
}

export enum EquipmentStatusEnum {
  AVAILABLE = "AVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
  RENTED = "RENTED",
}

export enum ReportTypes {
  DAILY = "Zilnic",
  WEEKLY = "Saptamanal",
  MONTHLY = "Lunar",
  YEARLY = "Anual",
}

// export enum ButtonTypes {
//   MAIN_BUTTON = "main_button",

// }
export enum NotificationType {
  RENTAL_STARTED = "RENTAL_STARTED",
  RENTAL_ENDED = "RENTAL_ENDED",
  USER_REGISTER = "USER_REGISTER",
  PAYMENT = "PAYMENT",
}

export enum SnackbarTypes {
  SUPPORT_EDIT_SUCCESS = "support_edit_success",
  SUPPORT_SAVE_SUCCESS = "support_save_success",
  SUPPORT_DELETE_SUCCESS = "support_delete_success",
  SUPPORT_ERROR = "support_error",
  BLOCK_SUCCESS = "block_success",
  UNBLOCK_SUCCESS = "unblock_success",
  VERIFY_SUCCESS = "verify_success",
  SETTINGS_SUCCESS = "settings_success",
  ERROR = "support_error",
}

export const lockerCurencies = [
  {
    key: "RON",
    value: "RON",
  },
  {
    key: "EUR",
    value: "EUR",
  },
];
